// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"94568162","488":"c8f64fe3","568":"6f1bf0e7"}[chunkId] + ".chunk.js";
};